import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '环境卫生“随手拍”';
const baseUrl = 'HJWSSSP20240314';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
    showfooter: true,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: false,
      },
    },
    {
      path: 'active',
      name: `${baseUrl}-active`,
      component: () => import('./pages/Active.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'conotent',
      name: `${baseUrl}-conotent`,
      component: () => import('./pages/JCcontent.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: true,
      },
    },
  ],
};
export default route;
